export default {
  title: 'product Form',
  detail: 'Create or update product information',

  name_fa: 'name fa',
  name_en: 'name en',
  price_irr: 'price irr',
  price_usd: 'price usd',
  stock_total: 'stock total',
  stock_reserved: 'stock reserved',
  stock_visible: 'stock visible',
  description_fa: 'description fa',
  description_en: 'description_en',
  category:'category',
  is_book:'Is book?',
  chapters:'chapters',
  media:'media',
  images:'images',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  back: 'back',
  success: 'success',
  error: 'error',
  save: 'save',
  loading: 'loading',
  saving: 'saving ...',
  yes:'yes',
  no:'no',
  placeholderNameFa: 'Enter name fa',
  placeholderNameEn: 'Enter name en',
  placeholderPriceIrr: 'Enter price irr',
  placeholderPriceUsd: 'Enter price usd',
  placeholderStockTotal: 'Enter stock total',
  placeholderStockReserved: 'Enter stock reserved',
  placeholderStockVisible: 'Enter stock visible',
  placeholderDescriptionFa: 'Enter description fa',
  placeholderDescriptionEn: 'Enter description en',
  placeholderCategory: 'Enter category',
  placeholderIsBook: 'this product is book',



}
